import { render } from "./ProjectData.vue?vue&type=template&id=1079e634&scoped=true"
import script from "./ProjectData.vue?vue&type=script&lang=js"
export * from "./ProjectData.vue?vue&type=script&lang=js"

import "./ProjectData.vue?vue&type=style&index=0&id=1079e634&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1079e634"]])

export default __exports__